import React from "react";
import { FaGlassMartiniAlt, FaVectorSquare, FaCubes } from "react-icons/fa";
import glassBanner from "../assets/banner6.jpg";

export default function TemperedGlassWorks() {
  return (
    <div className="MainBodySection py-5" style={{ backgroundColor: "#f9f9f9" }}>
      <div className="container position-relative">

        {/* HEADER */}
        <div className="text-center mb-5">
          <h2 className="main-section-title text-primary">
            Tempered Glass Works
          </h2>
          <p className="text-muted fs-6">
            High-quality tempered glass solutions for interiors, partitions, and custom installations.
          </p>
        </div>

        {/* BANNER IMAGE */}
        <div className="bg-light rounded shadow-sm mb-5 p-3">
          <img
            src={glassBanner}
            alt="Tempered Glass Works"
            className="img-fluid rounded w-100"
            style={{ maxHeight: 420, objectFit: "cover" }}
          />
        </div>

        {/* SERVICE DESCRIPTION */}
        <div className="bg-white rounded shadow-sm p-4 mb-5">
          <p className="text-muted fs-6 mb-4">
            Kitchen Kings TZ provides professional tempered glass installations tailored to residential and commercial interiors. Our solutions combine aesthetics, strength, and safety to elevate your spaces.
          </p>

          {/* KEY PRODUCTS / SERVICES */}
          <ul className="list-unstyled mb-4">
            <li className="mb-3 d-flex align-items-start">
              <FaGlassMartiniAlt size={22} className="me-3 text-primary" />
              <span>
                Kitchen Splashbacks: Custom tempered glass panels for a sleek and easy-to-clean kitchen finish.
              </span>
            </li>

            <li className="mb-3 d-flex align-items-start">
              <FaVectorSquare size={22} className="me-3 text-primary" />
              <span>
                Partitions & Doors: Stylish tempered glass partitions, office doors, and shower enclosures.
              </span>
            </li>

            <li className="mb-3 d-flex align-items-start">
              <FaCubes size={22} className="me-3 text-primary" />
              <span>
                Custom Glass Solutions: Decorative, frosted, or colored glass tailored to your design vision.
              </span>
            </li>
          </ul>

          {/* WORKFLOW / PROCESS */}
          <ol className="fs-6 mb-3">
            <li>Consultation to determine glass type, thickness, and finish requirements.</li>
            <li>Precise measurement, cutting, and tempering for safety and accuracy.</li>
            <li>Professional installation ensuring durability, aesthetics, and functionality.</li>
          </ol>

          <p className="text-muted fs-6 mt-3">
            Our tempered glass works bring modern elegance, durability, and safety to your interiors, whether for homes, offices, or commercial spaces.
          </p>
        </div>

      </div>
    </div>
  );
}
